module.exports = __webpack_public_path__ + "static/AshlyLauResume-cc2d388b474ddfc1b11f78c1c5e364bc.pdf";